export default __webpack_public_path__ + "static/media/19.50f68822.svg";